<template>
  <el-popover
    v-loading="loading"
    placement="right"
    @show="show"
    v-model="visible"
    class=""
    trigger="click">
    <el-row class="m-20">
      <el-radio-group v-model="type" @change="clearRate">
        <el-radio label="PERCENT">{{$t('common.percentage')}}</el-radio>
        <el-radio label="NET">{{$t('common.net')}}</el-radio>
      </el-radio-group>
    </el-row>
    <el-row class="m-20">
      <el-input-number :min="0" size="small" :controls="false" style="width:100%;" v-model="rate"></el-input-number>
    </el-row>
    <div class="right">
        <el-button class="m-10" @click="visible=false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" class="m-10" @click="apply">{{$t('common.apply')}}</el-button>
    </div>
    <span slot="reference">
      <span>{{$t('common.rate')}} : </span>
      <el-button class="p-0" type="text">
        <span>{{actualMarginRate}} {{symbol}}</span> <i class="el-icon-edit"></i>
      </el-button>
    </span>
  </el-popover>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'MarginRatePopover',
	props: {
    margin_rate : Number,
    margin_type : {type : String, default : 'PERCENT'}
  },
	components : {

	},
	data() {
		return {
      type : 'PERCENT',
      rate : parseFloat(localStorage.PURCHASE_ORDER_MARGIN_VALUE),
      visible : false,
      loading : false,
		}
	},
	computed : {
    symbol(){
      return this.margin_type=='PERCENT' ? '%' : '$';
    },
    actualMarginRate(){
      return this.margin_type=='PERCENT' ? this.margin_rate*100 : this.margin_rate;
    }
  },
	methods : {
    show(){
      this.type = this.margin_type;
      this.rate = this.margin_rate;
    },
    apply(){
      this.$emit('applyMargin',{type : this.type, rate : this.rate});
      this.visible = false;
    },
    clearRate(){
      if(this.type==this.margin_type){
        this.rate = this.margin_rate;
      }else{
        this.rate = 0;
      }
    }
  },
  created(){
  }
}
</script>
<style lang="scss">
@import '../assets/scss/_variables';


</style>
